import { useCallback, useMemo, useRef } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";

import moment from "moment";

import { LinearProgress } from "../application/LinearProgress";
import { TitleHeader } from "../components/page/TitleHeader";
import { BackButton } from "../components/page/BackButton";
import { useTranslation } from "../internationalisation/translation.hook";
import { CustomerDetailPage } from "./CustomerDetailPage";
import { useCreateRegistrationWithoutAppointmentAction } from "../registration/create-registration-dialog/create-registration-without-appointment-action.hook";
import { useUser } from "../user/UserProvider";
import { TaskResponseData, useTaskResponseAction } from "../task/task-response-action.hook";
import { useGardeningTasksByCustomerIdAndStatus } from "../gardening-task/gardener-view/gardening-tasks-gardener-view.hook";
import { NotFoundPage } from "../application/NotFoundPage";
import { collapseCustomerGardeningTasksToTheMostRelevantTask } from "../gardening-task/gardening-task.utility";

export const IntegratedCustomerDetailPage = () => {
    const { t } = useTranslation();
    const { customerId, tab } = useParams<{ customerId: string, tab: "current" | "past" }>();

    const history = useHistory();
    const goBack = useCallback(() => {
        history.push(`/customers/${tab}`);
    }, [history, tab]);

    const gardener = useUser();
    const gardeningTasks = useGardeningTasksByCustomerIdAndStatus(gardener.id, customerId, "found gardener");

    const gardeningTask = useMemo(() => {
        if ( gardeningTasks === undefined ) return undefined;

        return collapseCustomerGardeningTasksToTheMostRelevantTask(gardeningTasks);
    }, [gardeningTasks]);

    const createRegistration = useCreateRegistrationWithoutAppointmentAction();

    const redirect = useCallback((action: TaskResponseData["action"]) => {
        if ( action === "stop working for customer" ) return goBack();
    }, [goBack]);
    const taskResponseAction = useTaskResponseAction(redirect);

    const now = useRef(moment().toISOString(true)).current;

    if ( gardeningTask === null ) return <NotFoundPage />;
    if ( gardeningTask === undefined ) return <LinearProgress />;

    const backButton = <BackButton onClick={goBack} />;

    return (
        <>
            <TitleHeader button={backButton}>{t("LeftTabBar: customers-tab")}</TitleHeader>
            
            <CustomerDetailPage
                gardener={gardener}
                gardeningTask={gardeningTask}
                createRegistration={createRegistration}
                taskResponseAction={taskResponseAction}
                now={now}
            />
        </>
    );
};
